var _defs, _g, _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCargoAll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 990.3 726",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-1, .cls-2 {\r\n        stroke-width: 0px;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #3b66b0;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M595.3,53.1h0c0-8.8-7.2-16-16-16H22.2c-8.8,0-16,7.2-16,16v400c0,8.8,7.2,16,16,16h41c7.9,0,14.9-5.7,16-13.6,6.3-48.1,44.7-78,91.1-78s84.8,29.8,91.1,78c1,7.9,8,13.6,16,13.6h275.6c6.6-35.5,21.4-68.2,42.4-95.9V53.1h-.2ZM542,354.5H64.2V84.1h477.8v270.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M473.9,327.8c11.7,0,21.2-7.4,21.2-16.3v-173.4c0-9-9.6-16.3-21.2-16.3s-21.2,7.3-21.2,16.2v173.5c0,9,9.5,16.3,21.2,16.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M362.7,327.8c11.7,0,21.2-7.4,21.2-16.3v-173.4c0-9-9.6-16.3-21.2-16.3s-21.2,7.3-21.2,16.2v173.5c0,9,9.5,16.3,21.2,16.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M250.5,327.8c11.7,0,21.2-7.4,21.2-16.3v-173.4c0-9-9.6-16.3-21.2-16.3s-21.3,7.3-21.2,16.2v173.5c0,9,9.5,16.3,21.2,16.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M137.2,327.8c11.7,0,21.2-7.4,21.2-16.3v-173.4c0-9-9.6-16.3-21.2-16.3s-21.1,7.3-21.2,16.2v173.5c0,9,9.5,16.3,21.2,16.3Z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 170.3,
    cy: 475.8,
    r: 20
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M804.7,229.9l-46.7-67c-3-3.6-7.5-5.8-12.3-5.8h-58.4c-8.8,0-16,7.2-16,16v67c0,8.8,7.2,16,16,16h105.1c13.6,0,21-15.8,12.3-26.2h0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M907.3,324v-26.9c0-3.8-1.3-7.4-3.7-10.3l-130.5-176c-3-3.6-7.5-5.7-12.3-5.7h-117.5c-8.8,0-16,7.2-16,16v217.9c40-34.9,92.3-56,149.6-56s93.5,15.1,130.4,41ZM671.3,240.1v-67c0-8.8,7.2-16,16-16h58.5c4.7,0,9.2,2.1,12.3,5.8l46.7,67c8.7,10.4,1.3,26.2-12.3,26.2h-105.2c-8.8,0-16-7.2-16-16Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M170.3,407.8c-37.5,0-68,30.5-68,68s30.5,68,68,68,68-30.5,68-68-30.5-68-68-68ZM170.3,495.8c-11,0-20-9-20-20s9-20,20-20,20,9,20,20-9,20-20,20Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M785.7,326.9c-109.5,0-198.4,88.2-198.4,196.8s88.9,196.7,198.4,196.7,198.4-88.1,198.4-196.7-88.9-196.8-198.4-196.8h0ZM785.7,665.3c-49.6,0-93.5-25.2-119.1-63.3.6-39.2,79.4-60.6,119.1-60.6s118.4,21.5,119.1,60.6c-25.6,38.1-69.4,63.3-119.1,63.3ZM726.2,445c0-32.7,26.6-59,59.5-59s59.5,26.3,59.5,59-26.6,59-59.5,59-59.5-26.3-59.5-59Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCargoAll);
export default __webpack_public_path__ + "static/media/cargo-all.37abc08a7613deae29d882d576aaaed1.svg";
export { ForwardRef as ReactComponent };